<template>
  <div>
    <v-dialog />
    <ul class="tabs">
      <li class="tab1_1">
        <a href="javascript:;" name=".tab1_3">消息列表</a>
      </li>
      <!--<li class="tab1_2">
        <a href="javascript:;" name=".tab1_4">课程消息</a>
      </li>
      <li class="tab1_3">
        <a href="javascript:;" name=".tab1_5">报名消息</a>
      </li>-->
    </ul>
    <div class="tab_content">
      <!--系统消息-->
      <div class="tab1_3 wrap message_list">
        <h5 class="none_ts" v-if="lists.length == 0" style="text-align: center;">
          <img src="@/assets/images/none_data.jpg" alt="">
          <h4>暂无消息</h4>
        </h5>
        <dl v-if="lists.length > 0" v-for="item in lists" :key="item.id">
          <h3>{{item.title}}</h3>
          <dt><img src="@/assets/images/zy_2.jpg"/></dt>
          <dd>{{item.content}}</dd>
          <p class="r_time">系统管理员   {{item.updateDate}}<a class="del" @click="del(item.id)"></a></p>
          <!--a class="a_btn">去考试</a-->
        </dl>
        <!--dl>
          <h3>管理员给您分配了一门考试</h3>
          <dt><img src="@/assets/images/zy_2.jpg"/></dt>
          <dd>测试复制名称</dd>
          <p class="r_time">系统管理员   2018-05-22 14:53:37<a class="del" ></a></p>
          <a class="a_btn">去考试</a>
        </dl>
        <dl>
          <h3 class="focus">管理员给您分配了一门考试</h3>
          <dt><img src="@/assets/images/zy_2.jpg"/></dt>
          <dd>测试复制名称</dd>
          <p class="r_time">系统管理员   2018-05-22 14:53:37<a class="del"></a></p>
          <a class="a_btn">去报名</a>
        </dl-->
      </div>
      <!--/系统消息-->
    </div>
  </div>
</template>
<script>
  import utils from '@/utils'
import {init} from '@/assets/js/public_mem'
export default {
  components: { },
  data () {
    return {
      lists: [],
      pages: 0,
      filter: {
        pageNo: 1,
        pageSize: 6,
        delFlag: '0'
      }
    }
  },
  created () {
    this.getStationMsgList()
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
  },
  methods: {
    popup (msg) {
      this.$toasted.show(msg)
    },
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确认提交吗？',
        buttons: [
          {
            title: '确认',
            default: false,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    getStationMsgList () {
      this.$api.post(this.$global.messageApiPath, '/station/getStationUserMessageList', this.filter, r => {
        if (r.data && r.data.length>0) {
          this.lists = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        }
      })
    },
    del (id) {
      var that = this
      that.confirmBox({
        title: '删除',
        text: '确认删除吗?',
        yes () {
          that.$api.post(that.$global.messageApiPath, '/station/deleteStationMessageUser', {ids: id}, r => {
            that.popup('删除成功')
            that.getStationMsgList()
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/message.vue